export class TimeoutPromiseAsync {
  private readonly checkFn: () => Promise<boolean>;
  private readonly interval: number;
  private readonly timeout: number;

  constructor(checkFn: () => Promise<boolean>, interval: number, timeout: number) {
    this.checkFn = checkFn;
    this.interval = interval;
    this.timeout = timeout;
  }

  public async wait(): Promise<void> {
    const startTime = Date.now();
    while (true) {
      if (await this.checkFn()) {
        return;
      }

      if (Date.now() - startTime > this.timeout) {
        throw new Error('Operation timed out');
      }

      await new Promise(resolve => setTimeout(resolve, this.interval));
    }
  }
} 